import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIdPath = returnPath("/protocol/runsheets/:id");
export const getIndexPath = returnPath("/protocol/runsheets");
